import { initializeApollo } from 'gql/client'
import { PAGINA, SEARCH } from 'utils/queries'
import { RICERCA_ELEMENTS_PER_PAGE } from 'utils/settings'
import RicercaTemplate from 'components/templates/RicercaTemplate/RicercaTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

function Ricerca({ pagina, query, risultati }) {
  return <RicercaTemplate pagina={pagina} query={query} risultati={risultati} />
}

export const getServerSideProps = NextWrapper.getServerSideProps(async ({ query }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'ricerca' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  let risultati = null

  if (query?.q) {
    const {
      data: { search },
    } = await client.query({
      query: SEARCH,
      variables: {
        query: query.q,
        first: RICERCA_ELEMENTS_PER_PAGE,
      },
    })

    risultati = Object.assign({}, search)
    risultati.edges = risultati.edges.map((item) => item.node)
  }

  return {
    props: { pagina: pagina, query: query?.q || null, risultati },
  }
})

export default Ricerca
